import ServicePageLayout from "@/pages/services/components/ServicePageLayout";

const relatedServices = [
  { label: "Toitures-terrasses", href: "/services/toitures-terrasses" },
  { label: "Parkings (enrobés & asphalte)", href: "/services/parkings" },
  { label: "Dalles carrossables", href: "/services/dalles-carrossables" },
  { label: "Terrasses", href: "/services/terrasses" },
];

export default function EtancheiteIsolationPage() {
  return (
    <ServicePageLayout
      tag="Sur béton"
      title="Étanchéité + isolation thermique"
      subtitle="Complexes d'étanchéité avec isolation thermique intégrée sur support béton : sarking, ITE, toiture froide ou chaude — performance et économies d'énergie."
      heroImage="https://readdy.ai/api/search-image?query=cross%20section%20view%20of%20modern%20roofing%20insulation%20system%20with%20white%20rigid%20foam%20panels%20being%20installed%20under%20waterproof%20membrane%20on%20concrete%20roof%2C%20clean%20technical%20installation%2C%20bright%20daylight%2C%20professional%20construction%20photography%2C%20precise%20layered%20system%2C%20wide%20angle&width=1440&height=900&seq=ksbtp-iso-hero-001&orientation=landscape"
      heroAlt="Étanchéité isolation thermique KS BTP"
      intro="Combiner étanchéité et isolation thermique, c'est optimiser la performance énergétique de votre bâtiment tout en le protégeant durablement des infiltrations. KS BTP maîtrise les complexes d'étanchéité avec isolation intégrée sur support béton : toiture chaude, toiture froide, sarking, ITE. Nous sélectionnons les isolants adaptés (laine de roche, polyuréthane, polystyrène extrudé) et les membranes d'étanchéité compatibles pour garantir une solution pérenne et performante."
      techItems={[
        { icon: "ri-temp-hot-line", label: "Toiture chaude" },
        { icon: "ri-temp-cold-line", label: "Toiture froide" },
        { icon: "ri-stack-line", label: "Sarking" },
        { icon: "ri-home-gear-line", label: "ITE (isolation par l'extérieur)" },
        { icon: "ri-leaf-line", label: "Laine de roche & PIR" },
        { icon: "ri-bar-chart-line", label: "Bilan thermique RE2020" },
      ]}
      steps={[
        {
          number: "01",
          title: "Bilan thermique",
          description: "Analyse des déperditions thermiques, calcul des besoins en isolation et choix du complexe adapté.",
        },
        {
          number: "02",
          title: "Conception",
          description: "Définition du complexe étanchéité + isolation, sélection des matériaux et établissement du devis.",
        },
        {
          number: "03",
          title: "Mise en œuvre",
          description: "Pose de l'isolant et de la membrane d'étanchéité par nos équipes, dans le respect des DTU.",
        },
        {
          number: "04",
          title: "Contrôle & livraison",
          description: "Vérification de la continuité thermique, test d'étanchéité et remise des documents de garantie.",
        },
      ]}
      advantages={[
        "Double performance : étanchéité durable + isolation thermique optimisée",
        "Conformité RE2020 et réglementation thermique en vigueur",
        "Réduction significative des factures énergétiques",
        "Matériaux certifiés : laine de roche, PIR, polystyrène extrudé",
        "Éligibilité aux aides CEE et MaPrimeRénov' selon les cas",
        "Garantie décennale sur l'ensemble du complexe posé",
      ]}
      galleryImages={[
        {
          src: "https://readdy.ai/api/search-image?query=workers%20installing%20rigid%20polyurethane%20insulation%20panels%20on%20flat%20concrete%20roof%20before%20waterproofing%20membrane%2C%20clean%20white%20foam%20boards%2C%20professional%20construction%20team%2C%20bright%20daylight%2C%20technical%20installation&width=600&height=440&seq=ksbtp-iso-gal-001&orientation=landscape",
          alt: "Pose isolation polyuréthane toiture",
        },
        {
          src: "https://readdy.ai/api/search-image?query=completed%20roofing%20insulation%20system%20with%20waterproof%20membrane%20on%20top%2C%20clean%20layered%20system%20visible%20at%20edge%2C%20modern%20commercial%20building%2C%20professional%20architectural%20photography&width=600&height=440&seq=ksbtp-iso-gal-002&orientation=landscape",
          alt: "Complexe étanchéité isolation terminé",
        },
        {
          src: "https://readdy.ai/api/search-image?query=thermal%20imaging%20camera%20showing%20heat%20loss%20on%20building%20roof%2C%20professional%20energy%20audit%2C%20infrared%20photography%2C%20construction%20inspection%2C%20technical%20expertise&width=600&height=440&seq=ksbtp-iso-gal-003&orientation=landscape",
          alt: "Audit thermique bâtiment",
        },
      ]}
      relatedServices={relatedServices}
    />
  );
}
